import { SET_CLIENT_TYPE, SET_COUNTRY, SET_USER_TOKEN } from './constants'

export const setCountry = (payload) => ({
  type: SET_COUNTRY,
  payload
})

export const setClientType = (payload) => ({
  type: SET_CLIENT_TYPE,
  payload
})

export const setUserToken = (payload) => ({
  type: SET_USER_TOKEN,
  payload
})
